module.exports = __webpack_public_path__ + "img/profile_ic_bold.a170659d.svg";